import axiosInstance from '../protected';

import {getDocumentsUrl, getImportUrl} from '../api.config';

import {IDocument} from '../../shared/types/document.types';

export const DocumentService = {
  async get(id: string) {
    const res = await axiosInstance.get<IDocument>(getDocumentsUrl(`/${id}`));

    return res;
  },

  async getContent(id: string) {
    const res = await axiosInstance.get<Blob>(getDocumentsUrl(`/${id}/content`), {
      responseType: 'blob',
    });

    return res;
  },

  async importDevices(data: FormData) {
    const res = await axiosInstance.post<unknown>(getImportUrl('/dictionary/devices'), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return res;
  },

  async replaceDocument(id: string, srId: number, file: File) {
    const formData = new FormData();

    formData.append('docFile', file);

    const res = await axiosInstance.put<unknown>(getDocumentsUrl(`/replace/${id}`), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        srId,
      },
    });

    return res;
  },

  async updateDocumentDescription(docId: string, comment: string) {
    const res = await axiosInstance.post<unknown>(
      getDocumentsUrl(`/${docId}/comment`),
      {},
      {
        params: {
          comment: comment.trim(),
        },
      },
    );
    return res;
  },
};
